import * as S from "./CustomToast.style";
import { toast, Slide } from "react-toastify";
import { ReactComponent as IconChecked } from "@/styles/assets/svg/icon_checked_circle.svg";
import { ReactComponent as IconClose } from "@/styles/assets/svg/icon_close_bold.svg";

interface CustomToastProps {
  message: string;
  type: "success" | "error";
}
export const CustomToast = ({ message, type }: CustomToastProps) => {
  return (
    <S.CustomToast type={type}>
      {type === "success" && (
        <span>
          <IconChecked />
        </span>
      )}
      {type === "error" && (
        <span>
          <IconClose />
        </span>
      )}

      <p>{message}</p>
    </S.CustomToast>
  );
};

export const showToast = (message: string, type: CustomToastProps["type"]) => {
  toast(<CustomToast message={message} type={type} />, {
    theme: "light",
    position: "top-center",
    hideProgressBar: true,
    autoClose: 2000,
    closeButton: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    transition: Slide,
    className: "custom-toast",
  });
};
